<script setup lang="ts">
//
</script>

<template>
  <div class="sec-flyout-menu-component">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.sec-flyout-menu-component {
  max-width: 80%;
  margin: 0 auto;
  height: 85vh;
  width: 100%;
}
</style>
